import { AxiosResponse } from 'axios';
import { baseService } from '../base';
import { Webhook, WebhookEventType, WebhookStatus } from '../../types/webhook';
import { PaginatedResponse } from '../../types/common';

export interface WebhookQueryParams {
  page?: number;
  limit?: number;
  clientId?: string;
  status?: WebhookStatus;
  search?: string;
}

export interface CreateWebhookDto {
  url: string;
  clientId: string;
  events: WebhookEventType[];
  secret?: string;
  quickbooksEnabled?: boolean;
  quickbooksRealmId?: string;
  quickbooksOauthToken?: string;
}

export interface UpdateWebhookDto {
  url?: string;
  events?: WebhookEventType[];
  status?: WebhookStatus;
  secret?: string;
  quickbooksEnabled?: boolean;
  quickbooksRealmId?: string;
  quickbooksOauthToken?: string;
}

class WebhookService {
  private readonly baseUrl = '/webhooks';

  async getWebhooks(params: WebhookQueryParams = {}): Promise<PaginatedResponse<Webhook>> {
    const response: AxiosResponse<PaginatedResponse<Webhook>> = await baseService.get(
      this.baseUrl,
      { params }
    );
    return response.data;
  }

  async getWebhook(id: string): Promise<Webhook> {
    const response: AxiosResponse<Webhook> = await baseService.get(
      `${this.baseUrl}/${id}`
    );
    return response.data;
  }

  async createWebhook(data: CreateWebhookDto): Promise<Webhook> {
    const response: AxiosResponse<Webhook> = await baseService.post(
      this.baseUrl,
      data
    );
    return response.data;
  }

  async updateWebhook(id: string, data: UpdateWebhookDto): Promise<Webhook> {
    const response: AxiosResponse<Webhook> = await baseService.patch(
      `${this.baseUrl}/${id}`,
      data
    );
    return response.data;
  }

  async deleteWebhook(id: string): Promise<void> {
    await baseService.delete(`${this.baseUrl}/${id}`);
  }
}

export const webhookService = new WebhookService(); 